module.exports = __webpack_public_path__ + "static/lpo-68342e42a1385116c7fa49c6fd560ab2.png";